module.exports = __webpack_public_path__ + "img/logo_without_lottery.30769665.png";